import css from './index.module.scss';
import Modal from './modal';
import { FormatMoney } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getRecommendBundle, SolarCalcPage } from '@/constants/solar-calculator';
import NextImage from '@/components/NextImage';
import { getSolarRecommand } from '@/service/solar-calculator';

export default function Step5({ calObj, callBack }: any) {
    const { useLang, useState, useEffect, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('calculatorssolarpanels');
    const [showModal, setShowModal] = useState({ visible: false, num: 0 });
    const staticItems = getRecommendBundle(
        locale,
        calObj?.check1 === 'outdoor' ? ([0, 1, 2].includes(calObj?.check2) ? 'outdoor_1' : 'outdoor_2') : calObj?.check1,
        calObj?.check1 !== 'work' ? (calObj?.check4 === 0 && calObj?.totalPower <= 1 ? 'type1' : 'type2') : calObj?.totalPower > 1 ? 'type2' : 'type1',
    );
    const [items, setItems] = useState([...staticItems]);

    const handleBack = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step4, currentStep: 4 }, true);
    };

    useEffect(() => {
        const tempArr = [...items];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].price = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice;
                        if(!tempArr[k]?.img && res?.data?.img){
                            tempArr[k].img = res?.data?.img;
                        }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = staticItems?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setItems(tempArr);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div className={`step5 ${css.step5}`}>
            <p className="step5-title">{t('step5_title')}</p>
            <ul className="step5-box">
                {items?.map((item: any, k: number) => (
                    <li className="step5-item" key={k}>
                        <div className="img-box">
                            <NextImage webpSrc={item?.webp || item?.img} src={item?.img} alt={item.text} aria-label={item.text} />
                        </div>
                        <div className="text-box">
                            <p className={`tag ${k === 0 ? 'red' : 'yellow'}`}>{k === 0 ? t('step5_tag_recommend') : t('step5_tag_best_seller')}</p>
                            <p className="title">{item?.title}</p>
                            {!item?.hideConnection && <p className="connect" onClick={() => setShowModal({ visible: true, num: item?.num })}>
                                {t('step5_connection')}
                            </p>}
                            <div className="info">
                                {t('step5_time')} {item?.rechargeTime} {t('step5_time_unit')}
                                <br />
                                {t('step5_weight')} {item?.totalWeight} {t('step5_weight_unit')}
                            </div>
                            <div className="price">
                                <span className="discount">
                                    {t('step5_money_unit')}
                                    {FormatMoney(item.price)}
                                </span>
                                {item?.originalPrice && item?.originalPrice !== item.price && (
                                    <span className="original">
                                        {t('step5_money_unit')}
                                        {FormatMoney(item.originalPrice)}
                                    </span>
                                )}
                            </div>
                            {['us'].includes(locale) && (
                                <div className="payment">
                                    <span className="payment-text">
                                        {t.rich('step5_save', {
                                            // 分期付款，仅限us, 小于1700分三期，否则分六期， 向上取整
                                            save: FormatMoney(Math.ceil(item?.price / (item?.price >= 1700 ? 6 : 3))),
                                        })}
                                    </span>
                                    <span className="payment-logo">
                                        <NextImage
                                            src={require('@publicLocal/solar-calculator/affirm.png')}
                                            alt={t.rich('step5_save', {
                                                save: FormatMoney(Math.ceil(item?.price / (item?.price >= 1700 ? 6 : 3))),
                                            })}
                                            aria-label={t.rich('step5_save', {
                                                save: FormatMoney(Math.ceil(item?.price / (item?.price >= 1700 ? 6 : 3))),
                                            })}
                                        />
                                    </span>
                                    {'.'}
                                </div>
                            )}
                            <Link className="more" href={item.link}>
                                {t('step5_learn')}
                            </Link>
                        </div>
                    </li>
                ))}
            </ul>
            <div className="step5-btns">
                <button className="btn-back" onClick={handleBack}>
                    {t('common_back')}
                </button>
                {locale === 'au' && <Link className="btn-next" href={'https://au.ecoflow.com/pages/solar-generators'} target="_blank">
                    {'Learn More about Solar Generators'}
                </Link>}
            </div>
            {showModal?.visible && <Modal number={showModal?.num} callback={() => setShowModal({ visible: false, num: 0 })} />}
        </div>
    );
}
